import styled from 'styled-components';

import { CONVERSATION_LEFT_PADDING } from '@web/conversations/consts/layout';
import { ScrollableContainer } from '@web/components/ScrollableContainer/ScrollableContainer';

export const ItemsListWraper = styled(ScrollableContainer)`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  justify-content: flex-start;
  width: 100%;
`;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${CONVERSATION_LEFT_PADDING}px;
  min-height: 0;
  padding-top: 20px;
  margin-bottom: 20px;
`;

export const EmptySearchWrapper = styled.div`
  padding: 30px 50px 0 0;
`;
